<template>
	<div class="image-text container section ">
		<div class="image-text__wrapper">
			<div v-for="(item, index) in content.relation" :key="index" class="image-text__item">
				<div class="image-text__item-description" v-html="item.description"></div>
				<Card :key="index + 'image'" :item="item.image" cover-height="380px" :show-hover-state="false" />
			</div>
		</div>
	</div>
</template>

<script>
import Card from '@/components/Card'

export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		contentComp() {},
	},
	components: {
		Card,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.image-text {
	@include respond-below('phone') {
		padding: 0rem !important;
	}

	&__wrapper {
		display: grid;
		grid-gap: 5rem 4rem;
		grid-template-rows: repeat(auto-fit, minmax(230px, 1fr));
		@include respond-below('phone') {
			direction: initial;
			grid-gap: 1rem 2rem;
		}
	}
	&__item {
		display: grid;
		grid-gap: 5rem;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		align-items: center;
		direction: rtl;
		@include respond-below('phone') {
			grid-gap: 0rem 0rem;
		}
		&:nth-child(2n) {
			direction: initial;
		}

		&-description {
			padding: 3rem;
			direction: initial;

			@include respond-below('phone') {
				padding: 0 1.5rem 1.5rem;
				grid-row: 2;
			}
			h4 {
				margin-bottom: 0rem;
			}
		}
	}
}
</style>
